import { useEffect, useState } from 'react';
import { Form } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import Attachments from './attachments';
import GeneralDetails from './general-details';
import Notes from './notes';
import OutsideRecruiter from './outside-recruiter';
import Production from './production';
import Staff from './staff';
import { useGetRolesQuery } from '../../../store/apiSlices/recruitApiSlice';
import { DropdownModel } from '../../../models/dropdown.model';
import { OfficerRoles } from '../../../enums/enum';
import { setDirty } from '../../../store/reducers/unSavedChangesReducer';
import { useFormikRefs } from '../../../hooks/useFormikRef';
import { FormikRefs } from '../../../constants';

const Details = ({ isAddingDetails }: { isAddingDetails: boolean }) => {
	const dispatch = useDispatch();
	const { formikRefs } = useFormikRefs();
	const { getFieldProps, dirty } = useFormikContext();
	const rolesMasterData = useGetRolesQuery(null);
	const [roles, setRoles] = useState<DropdownModel[]>([]);

	useEffect(() => {
		if (!rolesMasterData.currentData?.value?.length) return;
		const roleId = rolesMasterData.currentData.value;
		setRoles(roleId);
	}, [rolesMasterData]);

	useEffect(() => {
		dispatch(
			setDirty({
				isDirty:
					dirty ||
					formikRefs[FormikRefs.attachmentsFormikRef]?.current
						?.dirty ||
					formikRefs[FormikRefs.notesFormikRef]?.current?.dirty ||
					false,
				isNavigationAllowed: true,
				isModalOpen: false,
			}),
		);
	}, [
		dirty,
		formikRefs[FormikRefs.attachmentsFormikRef]?.current?.dirty,
		formikRefs[FormikRefs.notesFormikRef]?.current?.dirty,
	]);

	const isLoanOfficer = () => {
		return (
			getFieldProps('general_details.role_id').value ===
			roles?.find((e) => e.value === OfficerRoles.loanOfficer)?.id
		);
	};

	return (
		<Form
			className={`w-full flex gap-x-4 ${isAddingDetails ? 'justify-center' : 'justify-between'}`}
		>
			<div
				className={`flex flex-col gap-y-4  ${isLoanOfficer() && !isAddingDetails ? 'w-2/5' : 'w-1/3'}`}
			>
				<GeneralDetails />
				<OutsideRecruiter />
				{isAddingDetails ? <Production /> : null}
			</div>
			{!isAddingDetails ? (
				<>
					<div
						className={`flex flex-col gap-y-4  ${isLoanOfficer() ? 'w-1/5' : 'w-1/3'}`}
					>
						<Staff />
						<Production />
					</div>
					<div
						className={`flex flex-col gap-y-4  ${isLoanOfficer() ? 'w-2/5' : 'w-1/3'} `}
					>
						<Attachments />
						<Notes />
					</div>
				</>
			) : null}
		</Form>
	);
};

export default Details;
